import { $nodesOfType, TextNode } from "lexical"
import {
  findAllSubstringIndices,
  getMatchingEndStart,
  getMatchingStart,
  removeFirstNChars,
  replaceLastNChars,
  replaceSubstring,
} from "./replaceHelpers"

export const onReplaceSingle = ({ from, to, nodeIndex, lastStateRef }, editor) => {
  editor.update(() => {
    const textNodes = $nodesOfType(TextNode)
    const searchData = []
    let bufferText = ""
    let bufferNodesData = []
    for (const node of textNodes) {
      const text = node.getTextContent()
      if (bufferText) {
        const isMatchingFirst = getMatchingStart(
          text,
          from.replace(new RegExp(bufferText, "i"), ""),
        )
        if (isMatchingFirst.length) {
          bufferText = bufferText + isMatchingFirst
          bufferNodesData.push({ node: node, matchText: isMatchingFirst })
        }
        //добавляем ноду состоящую из нескольких кусочков
        // но проверяем bufferNodesData
        // если он равен 1, то не добавляем
        //т.к создастся дубль. такие ноды добавляются выше
        if (bufferText.toLowerCase() === from.toLowerCase() && bufferNodesData.length > 1) {
          searchData.push({ startIndex: null, endIndex: null, nodesData: bufferNodesData })
          bufferText = ""
          bufferNodesData = []
        }
      }
      const allIndices = findAllSubstringIndices(text, from, node)
      searchData.push(...allIndices)
      const isMatching = getMatchingEndStart(text, from)
      if (isMatching.length) {
        bufferText = isMatching
        bufferNodesData = []
        bufferNodesData.push({ node: node, matchText: isMatching })
      }
    }

    //Замена
    const nodeForReplace = searchData[nodeIndex] || null
    if (nodeForReplace?.nodesData?.length === 1) {
      const text = nodeForReplace.nodesData[0].getTextContent()
      const newText = replaceSubstring(text, to, nodeForReplace.startIndex, nodeForReplace.endIndex)
      nodeForReplace.nodesData[0].setTextContent(newText)
    }
    if (nodeForReplace?.nodesData?.length >= 2) {
      const bufferNodesData = nodeForReplace.nodesData
      bufferNodesData.map((item, i) => {
        if (i === 0) {
          const text = item.node.getTextContent()
          const newText = replaceLastNChars(text, item.matchText.length, to)

          item.node.setTextContent(newText)
        }

        if (i > 0 && i < bufferNodesData.length - 1) {
          item.node.remove()
        }
        if (i === bufferNodesData.length - 1) {
          const text = item.node.getTextContent()
          const newText = removeFirstNChars(text, item.matchText.length)
          item.node.setTextContent(newText)
        }
        return undefined
      })
    }
  })
  setTimeout(() => {
    lastStateRef.current = editor.getEditorState()
  }, 0)
}
